<template>
    <Transition>
        <div style="margin-right: 10px;" v-if="candidate">
        <div class="form container px-2">
        <h5 class="mb-4"><b>I. HUMAN RELATIONS:</b></h5>

        <div class="d-flex flex-wrap mb-4">
            <span class="pe-0 me-2 ms-4">
                <p class="mb-0"><b>
                        How would you describe your relationship with:
                    </b></p>
            </span>
        </div>

        <div class="d-flex flex-wrap mb-5">
            <span class="pe-0 me-2 ms-4">
                <p class="mb-0"><b>
                        1. &nbsp; &nbsp;Your Senior Officer?
                    </b></p>
            </span>
            <span class="flex-fill p-0">
                <input v-model="seniorOfficerRelationship" type="text" class="form-control pb-0" placeholder="e.g. Excellent">
            </span>
        </div>

        <div class="d-flex flex-wrap mb-5">
            <span class="pe-0 me-2 ms-4">
                <p class="mb-0"><b>
                        2. &nbsp; &nbsp;Your Colleagues?
                    </b></p>
            </span>
            <span class="flex-fill p-0">
                <input v-model="colleaguesRelationship" type="text" class="form-control pb-0" placeholder="e.g. Excellent">
            </span>
        </div>

        <div class="d-flex flex-wrap mb-5">
            <span class="pe-0 me-2 ms-4">
                <p class="mb-0"><b>
                        3. &nbsp; &nbsp;Staff Working under you?
                    </b></p>
            </span>
            <span class="flex-fill p-0">
                <input v-model="subordinateRelationship" type="text" class="form-control pb-0" placeholder="e.g. Excellent">
            </span>
        </div>

        <div v-if="hodEmail" class="d-flex flex-wrap me-3">
            <span class="pe-0 me-2 ms-4">
                <p><b>HOD's email: </b>{{hodEmail}}</p>
            </span>
        </div>

        <div v-if="submitToHODDate" class="d-flex flex-wrap mb-4 me-3">
            <span class="pe-0 me-2 ms-4">
                <p><b>Submission to HOD date (Most recent): </b>{{submitToHODDate}}</p>
            </span>
        </div>
        <div class="d-flex flex-row-reverse mb-5">
            <button v-if="!submitToHODDate && !candidate.submitted" type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#staticBackdrop">Submit to HOD</button>
            <button @click="saveSection('view')" v-if="hodCommentDate" type="button" class="btn btn-success me-3">View HOD's comment</button>
            <button @click="saveSection('save')" type="button" class="btn btn-success me-3">Save Section</button>
            <button @click="saveSection('previous')" type="button" class="btn btn-success me-3">Previous Section</button>
        </div>
        <!--Submit to supervisor modal-->
        <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Submit to HOD</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="container mb-4">
                            <span class="flex-fill p-0">
                                <input type="text" class="form-control pb-0" name="hodEmail" v-model="hodEmail" placeholder="Head of Department Email">
                            </span>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="submit()" type="button" class="btn btn-success" data-bs-dismiss="modal">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</Transition>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'sectionI',
    emits: ['toggleLoader', 'setSection', 'submitted'],
    data() {
        return { candidate: '',
            seniorOfficerRelationship: '',
            colleaguesRelationship: '',
            subordinateRelationship: '',
            submitToHODDate: '',
            hodEmail: '',
            claimsVerification: '',
            hodComments: '',
            hodCommentDate: ''
        }
    },
    created() {
        this.$emit('setSection', 'Section I');
        this.setData()
    },
    methods: {
        async saveSection(page) {
            this.$emit('toggleLoader');

            var dataDetails = {
                seniorOfficerRelationship: this.seniorOfficerRelationship,
                colleaguesRelationship: this.colleaguesRelationship,
                subordinateRelationship: this.subordinateRelationship,
            }

            const res = await DataService.saveData(dataDetails);
            
            if (res){
                if (page == 'previous') {
                    this.$router.push('/sectionh')
                } else if (page == 'save') {
                    alert("Section saved.")
                } else if (page == 'view') {
                    this.$router.push("/sectionj&k")
                }
            }

            this.$emit('toggleLoader');
        },
        async submit() {
            this.$emit('toggleLoader');
            
            if (this.hodEmail) {
                var regex = /^[\w\-\.\+]+\@[a-zA-Z0-9\. \-]+\.[a-zA-z0-9]{2,4}$/;
                if (this.hodEmail.match(regex) == null){
                    alert ('Enter a correct email');
                    this.$emit('toggleLoader');
                    return
                }

                const date = new Date();

                var dataDetails = {
                    seniorOfficerRelationship: this.seniorOfficerRelationship,
                    colleaguesRelationship: this.colleaguesRelationship,
                    subordinateRelationship: this.subordinateRelationship,
                    submitToHODDate: date.getUTCDate() + '/' + (Number(date.getUTCMonth()) + 1) + '/' + date.getUTCFullYear(),
                    hodEmail: this.hodEmail.trim().toLowerCase()
                }

                const candidate = await DataService.saveData(dataDetails);

                if (candidate) {
                    alert("You have successfully submitted your documents to your HOD for certification. Inform them to check their email and inform you when they have certified you. After your HOD's certification, you still need to submit to your Dean in Section J & K, before final submission for appraisal in Section L.");
                    this.submitToHODDate = candidate.submitToHODDate;
                }
            } else {
                alert("Enter your HOD's email")
            }

            this.$emit('toggleLoader');
        },
        async setData() {
            window.scrollTo({ top: 0, behavior: 'smooth' });

            this.$emit('toggleLoader');

            const candidate = await DataService.getCandidate(JSON.parse(window.localStorage['user'])._id);
            
            if (candidate) { 
                if ((candidate.staffType == "Junior Non-academic") || (candidate.staffType == "Senior Non-academic")) {
                    this.$emit('toggleLoader');
                    this.$router.push({ path: `/section1` });
                    return
                }
                this.$emit('submitted', candidate.submitted);
                this.candidate = candidate;
                this.seniorOfficerRelationship = candidate.seniorOfficerRelationship ? candidate.seniorOfficerRelationship : '';
                this.colleaguesRelationship = candidate.colleaguesRelationship ? candidate.colleaguesRelationship : '';
                this.subordinateRelationship = candidate.subordinateRelationship ? candidate.subordinateRelationship : '';
                this.submitToHODDate = candidate.submitToHODDate ? candidate.submitToHODDate : '';
                this.hodEmail = candidate.hodEmail ? candidate.hodEmail : '';
                this.claimsVerification = candidate.claimsVerification ? candidate.claimsVerification.comment : '';
                this.hodComments = candidate.hodComments ? candidate.hodComments.comment : '';
                this.hodCommentDate = candidate.hodComments ? candidate.hodComments.date : '';
            }
            
            this.$emit('toggleLoader')
        }
    }
}
</script>